import { Product } from '../types/products'

/**
 * It sorts products by skuCode in alphabetical order
 * The skuCode is made in a fashion so that the sorting can happen automatically:
 * the first part (before the underscore) concerns the model, the second the color and the last 2 digits the size.
 */
export const sortProducts = (products: Product[]): Product[] => {
	if (!products || products.length === 0) {
		return []
	}

	return [...products].sort((a, b) => {
		const skuComparison = a.skuCode.localeCompare(b.skuCode, 'en', {
			sensitivity: 'base',
		})

		if (skuComparison !== 0) {
			return skuComparison
		}

		return a.UPC.localeCompare(b.UPC, 'en', { sensitivity: 'base' })
	})
}
